const SettingsNotifications = () => <>hello world!</>;

export default SettingsNotifications;
